import { useCallback, useMemo } from 'react'

import analyticsUtil from 'legacy/utils/analytics'

import { buildCategoryName, buildTagNames } from '../utils/analyticsUtils'

export function useAnalytics() {
  const track = useCallback(
    (names, params) => analyticsUtil.track(buildCategoryName(names), params),
    []
  )

  const trackIntercom = useCallback(
    (names, params) => analyticsUtil.trackIntercom(buildCategoryName(names), params),
    []
  )

  const tag = useCallback(tags => analyticsUtil.tag(buildTagNames(tags)), [])

  const analytics = useMemo(
    () => ({
      track,
      trackIntercom,
      tag,
    }),
    [tag, track, trackIntercom]
  )

  return { analytics }
}
